'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: type,
    payload: payload,
    meta: meta
  };
};

module.exports = exports['default'];